import { IIdentifiable } from '@/common/models/models'
import { CmOffice, ICmOffice } from '@/common/models/data/common/cm-office'
import { IRole, Role } from '@/common/models/data/common/role'
import { IStaff } from '@/common/models/data/dashboard/staff/staff'

// region User

interface IUser extends IIdentifiable {
    email: string
    name: string

    active: boolean
    archived: boolean
    publishable_as: boolean

    password?: string
    password_confirmation: string
    password_updated_at: null | string

    offices?: Array<ICmOffice>
    roles?: Array<IRole>
}

class User implements IUser {
    id = 0
    email = ''
    name = ''

    active = false
    archived = false
    publishable_as = false

    password = ''
    password_confirmation = ''
    password_updated_at: null | string = ''

    offices: Array<CmOffice> = []
    roles: Array<Role> = []

    constructor (dto?: IUser) {
        if (dto) {
            this.id = dto.id
            this.email = dto.email
            this.name = dto.name

            this.active = dto.active
            this.archived = dto.archived
            this.publishable_as = dto.publishable_as
            this.password_updated_at = dto.password_updated_at ?? ''

            this.offices = dto.offices?.map(office => new CmOffice(office)) ?? []
            this.roles = dto.roles?.map(role => new Role(role)) ?? []
        }
    }
}

type IUserBasicData = Pick<IUser, 'id' | 'name'> & {
    staff?: Array<IStaff>
}
type IUserCredentials = Required<Pick<IUser, 'email' | 'password'>>

class UserBasicData implements IUserBasicData {
    id = 0
    name = ''

    staff?: Array<IStaff> = undefined

    constructor (data?: IUserBasicData) {
        if (data) {
            this.id = data.id
            this.name = data.name
            this.staff = data.staff
        }
    }
}

type IUserRequest = {
    name: string
    email: string
    password?: string
    password_confirmation?: string
    active: boolean
    archived: boolean
    publishable_as: boolean
    offices: Array<number>
    roles: Array<number>
}

type IChangePasswordRequest = Required<Pick<IUser, 'password' | 'password_confirmation'>>

class ChangePasswordRequest implements IChangePasswordRequest {
    password = ''
    password_confirmation = ''
}

// endregion

// region OAuth

type IAuthenticatedUserData = Pick<IUser, 'id' | 'name' | 'email' | 'password_updated_at'> & {
    roles: Array<string>
    permissions: Array<string>
    offices: Array<ICmOffice>
}

interface IOAuthResponse {
    token_type: string
    expires_in: number
    access_token: string
    refresh_token: string
}

type IOAuthAuthenticationData = IOAuthResponse & {
    login_time: number
    data: IAuthenticatedUserData
}

// endregion

export {
    IUser, User, IUserBasicData, UserBasicData, IUserCredentials, IUserRequest,
    IChangePasswordRequest, ChangePasswordRequest,
    IAuthenticatedUserData, IOAuthResponse, IOAuthAuthenticationData
}
